import { auth, db } from "@/lib/firebase";
import { doc, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";

const SUB = "rsvps";

/**
 * Explicit UID API (preferred)
 */
export async function rsvpGoing(uid: string, eventId: string) {
  const ref = doc(db, "events", eventId, SUB, uid);
  await setDoc(
    ref,
    {
      uid,
      going: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: false }
  );
}

export async function rsvpClear(uid: string, eventId: string) {
  const ref = doc(db, "events", eventId, SUB, uid);
  await deleteDoc(ref);
}

// Toggle using current auth user (true => going, false => clear)
export async function toggleRsvp(eventId: string, nextGoing: boolean) {
  const u = auth.currentUser;
  if (!u) throw new Error("auth_required");
  return nextGoing ? rsvpGoing(u.uid, eventId) : rsvpClear(u.uid, eventId);
}

/**
 * Legacy convenience helper using current auth user.
 */
export async function setRsvp(eventId: string, going: boolean) {
  const u = auth.currentUser;
  if (!u) throw new Error("auth_required");
  return going ? rsvpGoing(u.uid, eventId) : rsvpClear(u.uid, eventId);
}
